export default __webpack_public_path__ + "static/media/ZingCreateActionH2@3x.f92b5fea.png";